import "./index.scss";
import React from 'react';
import { useLanguage } from "../../../context/LanguageContext";

const LanguageSelector = () => {
  const { currentLanguage, availableLanguages, changeLanguage, isLoading } = useLanguage();

  const handleLanguageChange = (event) => {
    changeLanguage(event.target.value);
  };

  return (
    <div className="language-selector">
      <select
        value={currentLanguage}
        onChange={handleLanguageChange}
        disabled={isLoading}
        className="language-select"
      >
        {availableLanguages.map((language) => (
          <option key={language.code} value={language.code}>
            {language.name}
          </option>
        ))}
      </select>
      {isLoading && <span className="loading-indicator">⌛</span>}
    </div>
  );
};

export const LanguageDropdown = () => {
  const { currentLanguage, availableLanguages, changeLanguage, isLoading } = useLanguage();

  return (
    <div className="language-dropdown">
      <div className="current-language">
        {currentLanguage.toUpperCase()}
        {isLoading && <span className="loading-indicator"> ⌛</span>}
      </div>
      <div className="dropdown-content">
        {availableLanguages.map((language) => (
          <button
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            disabled={isLoading || language.code === currentLanguage}
            className={`language-option ${language.code === currentLanguage ? 'active' : ''}`}
          >
            {language.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;
